import { WorkspaceRole } from 'clients/app/src/api/workspaces/getWorkspaceMembers';

import {
  TeacherApplicationContext,
  useTeacherApplicationContext,
} from '~shared/context/TeacherApplicationContext';
import { useGetWorkspaceCode } from '~teacher/hook/workspaces/code';

interface UseInviteCodeParams {
  workspaceId: string;
  workspaceRole: WorkspaceRole;
}

export function useInviteCode({
  workspaceId,
  workspaceRole,
}: UseInviteCodeParams) {
  const teacherApplicationContext = useTeacherApplicationContext();
  return useGetWorkspaceCode({
    workspaceId: workspaceId,
    workspaceRole: workspaceRole,
    select: ({ code }) => {
      return {
        code: getAccessCode({ code, teacherApplicationContext }),
        isEnabled: code !== undefined,
      };
    },
  });
}

function getAccessCode({
  code,
  teacherApplicationContext,
}: {
  code: string;
  teacherApplicationContext: TeacherApplicationContext;
}) {
  if (code == null) {
    return undefined;
  }

  switch (teacherApplicationContext) {
    case TeacherApplicationContext.ShowbieAssessments:
      return `BIB-${code}`;
    case TeacherApplicationContext.Socrative:
      return `LIB-${code}`;
    default:
      return code;
  }
}
